import {type EffectCallback, useEffect} from 'react'

/**
 * Хук, который отрабатывает единожды при монтировании компонента.
 * @param effect React-эффект
 */
export function useMountEffect(effect: EffectCallback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps -- Нужно для единичного вызова хука на маунт
  useEffect(effect, [])
}
